import UrlHelpers from "./url";

interface IMediamanagerLinks {
    upload: string
    public: string
}

declare type MediamanagerCallback = (string) => void;


export class MediamanagerFileInputHandler {
    constructor(input: HTMLInputElement, callback: MediamanagerCallback) {
        this._createOnChangeEvent(input, callback);
    }

    private _createOnChangeEvent = (input: HTMLInputElement, callback: MediamanagerCallback) => {
        if (!input) {
            throw new Error("Parameter 'input' missing")
        }
        if (!callback) {
            throw new Error("Parameter 'callback' missing")
        }
        input.addEventListener(
            "change",
            () => {
                this._handleInputChange(input, callback);
            },
            false
        );
    };

    private _handleInputChange = (input: HTMLInputElement, callback: MediamanagerCallback) => {
        const file: File = this._getFile(input);
        if (!file) {
            console.error("Failed to load file.");
            return;
        }
        const baseurl: string = UrlHelpers.getLinkRelHref('mediamanager');
        if(baseurl) {
            this._getTarget(baseurl).then(location => {
                this._getLinks(baseurl + location).then((links: JSON) => {
                    console.log(`public:${links["public"]}`);
                    console.log(`upload:${links["upload"]}`);
                    const cb = () => {
                        callback(String(links["public"]))
                    };
                    this._upload(String(links["upload"]), file, cb);
                });
            });
        } else {
            console.error("'mediamanager' link relation not found!");
        }
    };

    private _upload = (url: string, file: File, cb: any) => {
        console.log(`Call 'PUT' to source ${url}`);
        fetch(url, {
            method: 'PUT',
            body: file,
            headers: {
                'Content-Type': file.type,
                'Content-Disposition': `filename="${file.name}"`
            },
            credentials:"same-origin"
        }).then(r => {
            console.log(r.statusText);
            cb();
        });
    };

    private _getFile = (input: HTMLInputElement): File => {
        if (null != input.files && 0 < input.files.length) {
            return input.files[0];
        }
        return null;
    };

    private _getTarget = (url: string): Promise<string | void> => {
        //TODO: Errorhandling - bisher wird ein GET gefeuert, auch wenn kein location header und damit keine valide URL zurückkommt
        // Feedback für User bei Fehlern fehlt
        console.log(`Call 'POST' to source ${url}`);
        return fetch(url,
            {
                method: "POST",
                headers: new Headers(
                    {
                        'Accept': 'application/json'
                    }
                ),
                credentials: "same-origin"
            }
        ).then(r => {
                console.log(`Return status: ${r.status}`);
                if (r.status !== 201 || !r.headers.get('Location').toString()) {
                    throw "Missing location header"
                }
                return r.headers.get("Location").toString();

            }
        ).catch(e => console.warn(`Request to ${url} failed! Error: ${e}`));
    };

    private _getLinks = (url: string): Promise<void | JSON> => {
        console.log(`Call 'GET' to source ${url}`);
        return fetch(url,
            {
                method: "GET",
                credentials: "same-origin"
            }
        ).then(r => {
                console.log(`Return status: ${r.status}`);
                if (r.status == 200) {
                    return r.json();
                }
            }
        ).then(json => {
                if (json.hasOwnProperty('_links')) {
                    return json["_links"];
                }
                throw "No links found in response";
            }
        ).catch(e => console.log(`Request to ${url} failed! Error: ${e}`));
    };

}